const PREVIEW_SEEK_TIME = 0.001;
const INITIALIZED_ATTR = 'data-video-preview-initialized';

function seekVideoToPreviewFrame(video) {
  const applySeek = () => {
    if (video.readyState < 1) {
      return;
    }

    const duration = Number.isFinite(video.duration) ? video.duration : PREVIEW_SEEK_TIME;
    const targetTime = duration > PREVIEW_SEEK_TIME ? PREVIEW_SEEK_TIME : 0;

    try {
      if (Math.abs(video.currentTime - targetTime) > 0.0005) {
        video.currentTime = targetTime;
      }
    } catch (error) {
      // Safari may reject seek until enough data is buffered.
      console.error('Failed to seek video for preview: ', error);
    }
  };

  if (video.readyState >= 1) {
    applySeek();
  }

  video.addEventListener('loadedmetadata', applySeek, { once: true });
  video.addEventListener('loadeddata', applySeek, { once: true });
  video.addEventListener('canplay', applySeek, { once: true });

  try {
    video.load();
  } catch (error) {
    console.error('Failed to load video for preview: ', error);
  }
}

function initWorkCardVideoPreview(video) {
  if (!(video instanceof HTMLVideoElement)) {
    return;
  }

  if (video.getAttribute(INITIALIZED_ATTR) === '1') {
    return;
  }

  video.setAttribute(INITIALIZED_ATTR, '1');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        seekVideoToPreviewFrame(video);
        observer.disconnect();
      });
    }, { rootMargin: '50px 0px', threshold: 0.01 });

    observer.observe(video);
    return;
  }

  seekVideoToPreviewFrame(video);
}

function initWorkCardVideoPreviews(root = document) {
  root.querySelectorAll('.js-work-card-video-preview').forEach((video) => {
    initWorkCardVideoPreview(video);
  });
}

export { initWorkCardVideoPreviews };
